import { render, staticRenderFns } from "./accessories.vue?vue&type=template&id=1cd44700"
import script from "./accessories.vue?vue&type=script&lang=js"
export * from "./accessories.vue?vue&type=script&lang=js"
import style0 from "./accessories.vue?vue&type=style&index=0&id=1cd44700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductAccessory: require('/app/components/product/accessory.vue').default})
